<template>
    <access-denied v-if="accessDenied" title="cliente" />
    <lateral-content v-model="showModal" :title="setTilte()" header confirmClose v-else>
        <template v-slot:header-right>
            <b-button
                type="is-warning is-silver"
                icon-right="close"
                @click="showModal = false"
                :disabled="isSaving"
                v-tippy 
                :title="$t('fechar')"
            />
            <b-button
                class="ml-2"
                v-if="
                    (idcontrato == 0 && permissao.create) || (idcontrato != 0 && permissao.update)
                "
                v-show="abas[abaSelecionada] == 'geral'"
                @click="save()"
                :disabled="isSaving"
                type="is-primary"
            >
                {{ $t('salvar') }}
                <button-loader :isSaving="isSaving" />
            </b-button>
        </template>
        <loader v-if="isLoading" />
        <div class="contract" v-else-if="showModal && !isLoading">
            <template v-if="idcontrato != 0">
                <ul class="nav nav-tabs nav-tabs-children">
                    <li
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                        :key="i"
                        v-for="(aba, i) in abas"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>

                <!-- CONJUNTO DE ABAS - MOBILE -->
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            {{ $t(abas[abaSelecionada]) }}
                        </span>
                        <em class="mdi mdi-chevron-down"></em>
                    </div>

                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaSelecionada == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        {{ $t(aba) }}
                    </b-dropdown-item>
                </b-dropdown>
            </template>

            <Geral
                ref="abaContrato"
                v-if="abasAbertas['geral'] && permissao.read"
                v-show="abas[abaSelecionada] == 'geral'"
                :idcontrato="idcontrato"
                :permissao="permissao"
                @voltar="$emit('voltar', true)"
                @isSaving="isSaving = $event"
                @reloadData="$emit('reloadData', true)"
                @idcontrato="reloadToEdit($event)"
            />

            <Lps
                ref="abaLps"
                v-if="abasAbertas['lps'] && permissao.read"
                v-show="abas[abaSelecionada] == 'lps'"
                :idcontrato="idcontrato"
                :permissao="permissao"
                @voltar="$emit('voltar', true)"
                @isSaving="isSaving = $event"
            />

            <Produto
                ref="abaRuptura"
                v-if="abasAbertas['ruptura-troca'] && permissao.read"
                v-show="abas[abaSelecionada] == 'ruptura-troca'"
                :idcontrato="idcontrato"
                :permissao="permissao"
                tipo="R"
                :reloadData="reloadData"
                @voltar="$emit('voltar', true)"
                @isSaving="isSaving = $event"
                @reloadData="reloadData = $event"
            />

            <Produto
                ref="abaVencimento"
                v-if="abasAbertas['vencimento'] && permissao.read"
                v-show="abas[abaSelecionada] == 'vencimento'"
                :idcontrato="idcontrato"
                :permissao="permissao"
                tipo="V"
                :reloadData="reloadData"
                @voltar="$emit('voltar', true)"
                @isSaving="isSaving = $event"
                @reloadData="reloadData = $event"
            />

            <Produto
                ref="abaTomadaPreco"
                v-if="abasAbertas['tomada-preco'] && permissao.read"
                v-show="abas[abaSelecionada] == 'tomada-preco'"
                :idcontrato="idcontrato"
                :permissao="permissao"
                tipo="T"
                :reloadData="reloadData"
                @voltar="$emit('voltar', true)"
                @isSaving="isSaving = $event"
                @reloadData="reloadData = $event"
            />
            <Produto
                ref="abaReposicao"
                v-if="abasAbertas['reposicao'] && permissao.read"
                v-show="abas[abaSelecionada] == 'reposicao'"
                :idcontrato="idcontrato"
                :permissao="permissao"
                tipo="P"
                @voltar="$emit('voltar', true)"
                @isSaving="isSaving = $event"
            />
        </div>
    </lateral-content>
</template>

<script>
import Geral from '@/components/promotor/cliente/abas/contrato/abas/Geral.vue';
import Lps from '@/components/promotor/cliente/abas/contrato/abas/Lps.vue';
import Produto from '@/components/promotor/cliente/abas/contrato/abas/Produto.vue';

export default {
    props: {
        // ativo/inativo
        value: {
            type: Boolean,
            default: false,
        },
        idcontrato: {
            type: Number,
            default: 0,
        },
    },
    components: {
        Geral,
        Lps,
        Produto,
    },
    data() {
        return {
            showModal: false,
            accessDenied: false,
            abaSelecionada: 0,
            abas: ['geral', 'lps', 'ruptura-troca', 'vencimento', 'tomada-preco', 'reposicao'],
            abasAbertas: {},
            permissao: false,
            isSaving: false,
            isLoading: false,
            title: this.$t('contrato'),
            reloadData: false,
        };
    },
    watch: {
        value(val) {
            this.showModal = val;
        },
        showModal(val) {
            this.$emit('input', val);
            if (!val) {
                this.abaSelecionada = 0;
                this.abasAbertas['geral'] = true;
            }
        },
    },
    created() {
        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'clientes');
        if (!this.permissao.read) {
            this.accessDenied = true;
            return;
        }

        this.abasAbertas['geral'] = true;
    },

    methods: {
        setTilte() {
            let temp = this.idcontrato == 0 ? this.$t('adicionar') : this.$t('editar');
            return temp + ' ' + this.$t('contrato');
        },
        save() {
            this.$refs.abaContrato.save();
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        reloadToEdit(idcontrato) {
            this.$emit('idcontrato', idcontrato);
            this.$emit('reloadData', true);
            this.isLoading = true;
            setTimeout(() => {
                this.isSaving = false;
                this.isLoading = false;
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
.is-silver {
    color: $semi-title-color;
    box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
    @include exclude-button();
}
.contract {
    padding: 10px;
    height: 100%;
    display: flex;
    flex-direction: column;
    @media only screen and (min-width: 761px) {
        .mobile-tab-list {
            display: none;
        }
    }
    @media only screen and (max-width: 760px) {
        .nav.nav-tabs.nav-tabs-children {
            display: none;
        }
    }
    .nav-tabs-children {
        width: 100%;
        display: flex;
        li > a {
            text-transform: capitalize;
        }
        li > ::after {
            bottom: -4px;
            border-width: 2px;
        }
    }
    .mobile-tab {
        cursor: pointer;

        &-list {
            width: calc(100% + 40px);
            margin-top: 20px;
            margin-bottom: 20px;
            margin-left: -20px;
            padding-right: 20px;
            padding-bottom: 5px;
            padding-left: 20px;
            border-bottom: 1px solid $table-border;
            justify-content: center;

            &::after {
                content: '';
                border: 3px solid $primary-color-click;
                border-radius: 100px;
                position: absolute;
                width: calc(100% - 40px);
                bottom: -3px;
            }

            &-item {
                text-transform: uppercase;
                font-weight: 600;
                color: $text-color;

                &.active {
                    color: $primary-color-click;
                }
            }
        }

        &-text {
            text-transform: uppercase;
            font-weight: 600;
            color: $primary-color-click;

            & ~ i {
                color: $primary-color-click;
            }
        }
    }
}
@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
